// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Fp","buttonPrev":"e_Gp","buttonNext":"e_Hp","hidden":"e_Ip","iconPrev":"e_Jp","iconNext":"e_Kp","scrollView":"e_Lp","card":"e_Mp","scroller":"e_Np"};